import { customElement } from "lit/decorators.js";
import { html } from "lit";
import { BaseComponent } from "../../base-component/base-component";
import { MessageTemplateId } from "../../../common/constants/api-constants";
import { MessageType } from "../global-message.interface";

@customElement('mhecomm-school-pricing-alert')
export class SchoolPricingAlert extends BaseComponent {

  renderComp() {
    return html `
      <mhecomm-alert
        id="school-pricing-info"
        type="${MessageType.info}"
        message=${MessageTemplateId.PRICING_FOR_SCHOOL_ACCOUNTS}
        data-automation-id="school-pricing-info"
      ></mhecomm-alert>`
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-school-pricing-alert': SchoolPricingAlert;
  }
}